import MapStore from '../stores/MapStore';

export default new MapStore();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/storeInstances/mapStore.ts